import { render, staticRenderFns } from "./PhotowallList.vue?vue&type=template&id=8ff44064&"
import script from "./PhotowallList.vue?vue&type=script&lang=js&"
export * from "./PhotowallList.vue?vue&type=script&lang=js&"
import style0 from "./PhotowallList.vue?vue&type=style&index=0&id=8ff44064&prod&lang=scss&"
import style1 from "./PhotowallList.vue?vue&type=style&index=1&id=8ff44064&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports